"use client";

import { useEffect } from "react";

interface EventBriteFormProps {
  eventId?: string;
  onOrderComplete?: (orderData: any) => void;
  onWidgetReady?: () => void;
  theme?: string;
}

export default function EventBriteForm({
  eventId = "",
  onOrderComplete,
  onWidgetReady,
  theme = "default",
}: EventBriteFormProps) {
  useEffect(() => {
    const loadScript = (src: string): Promise<void> => {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = () => (window.EBWidgets ? resolve() : reject());
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    const loadEventBriteWidget = () => {
      if (window.EBWidgets) {
        window.EBWidgets.createWidget({
          widgetType: "checkout",
          eventId: eventId,
          modal: false,
          iframeContainerId: `eventbrite-widget-${eventId}`,
          onOrderComplete: (orderData: any) => {
            if (onOrderComplete) {
              onOrderComplete(orderData);
            }
          },
        });

        if (onWidgetReady) {
          onWidgetReady();
        }

        // Adjust iframe after widget is injected
        setTimeout(() => {
          const iframe = document.querySelector(
            `#eventbrite-widget-${eventId} iframe`
          ) as HTMLIFrameElement | null;
          if (iframe) {
            iframe.style.height = "600px";
            iframe.style.width = "100%";
          }
        }, 500);
      }
    };

    (async () => {
      try {
        await loadScript(
          "https://www.eventbrite.com/static/widgets/eb_widgets.js"
        );
      } catch {
        console.warn("Failed to load EventBrite widget script.");
        return;
      }
      loadEventBriteWidget();
    })();

    return () => {
      const container = document.getElementById(`eventbrite-widget-${eventId}`);
      if (container) container.innerHTML = "";
    };
  }, [eventId, onOrderComplete, onWidgetReady]);

  return (
    <div
      id={`eventbrite-widget-${eventId}`}
      className={`eventbrite-form-container theme-${theme}`}
    />
  );
}
